/*! Copyright © 2026 Kontextlab GmbH. All rights reserved. */

import { getSocialPanel } from '../lib/instances.js';

export function init() {
        const toggle = document.querySelector('.share-button');
        const panel = document.querySelector('.share-panel');
        if (!toggle || !panel) return;
        if (!getSocialPanel()?.isEnabled()) {
            toggle.style.display = 'none';
            return;
        }
        let mapUrl = `${location.origin}${location.pathname}`;
        const enabled = new Set(getSocialPanel().enabledServices());
        [...panel.querySelectorAll('.social-share-btn')].forEach((btn) => {
            if (!enabled.has(btn.id)) btn.style.display = 'none';
            btn.addEventListener('click', (ev) => {
                ev.stopPropagation();
                const svc = btn.id;
                const url = getSocialPanel().getServiceLinkUrl(
                    svc,
                    `${mapUrl}${location.hash}`,
                    document.title || ''
                );
                svc === 'email' ? (location.href = url) : window.open(url);
            });
        });
        toggle.style.display = '';
        const syncExpanded = () =>
            toggle.setAttribute(
                'aria-expanded',
                panel.classList.contains('dropped') ? 'true' : 'false'
            );
        toggle.addEventListener('click', (ev) => {
            ev.stopPropagation();
            panel.classList.toggle('dropped');
            syncExpanded();
        });
        const map = document.getElementById('map');
        if (map) {
            const close = () => {
                panel.classList.remove('dropped');
                syncExpanded();
            };
            map.addEventListener('click', close);
            map.addEventListener('wheel', close, { passive: true });
        }
        window.addEventListener('message', (event) => {
            if (typeof event.data === 'object' && event.data?.embedUrl)
                mapUrl = event.data.embedUrl;
        });
}
